// extracted by mini-css-extract-plugin
export var categoryIcon = "_dv-5";
export var connectorContainer = "_dv-1";
export var connectorLine = "_dv-0";
export var minHeight0 = "_dv-6";
export var relativeUnitValueSelector = "_dv-2";
export var trifoldSelectorBody = "_dv-4";
export var trifoldSelectorList = "_dv-3";